// extracted by mini-css-extract-plugin
export default {"wrapper":"BoletoBarCodeDisplay_wrapper__MYVbS","barcode":"BoletoBarCodeDisplay_barcode__ZgcvK"};